import { createContext } from "react";

/** The panel context data. */
export interface PanelContextData {

  /** The current panel level in the visual hierarchy. */
  readonly level: number;
}

/** The panel context. */
export const PanelContext = createContext<PanelContextData>({ level: -1 });
